module.exports = __webpack_public_path__ + "static/media/sofia-gameiro.ef17d0fb.jpg";